<template>
  <div id="app">
    <NavBar v-if="existingUser"/><!-- && user.emailVerified-->
    <router-view/>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import NavBar from '@/components/NavBar.vue';

export default {
  name: 'App',
  components: {
    NavBar
  },
  methods: {
    ...mapActions(['logOut'])
  },
  computed: {
    ...mapGetters(['existingUser']),
    ...mapState(['user'])
  }
}

</script>

<style>
@import './assets/css/hs-mega-menu.css';
@import './assets/css/select2.min.css';
@import './assets/font-awesome/css/all.min.css';
body {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #525f7f;
    text-align: left;
    background-color: #fcfcff;
}
</style>
